var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v("PAGE 404")]),_c('p',{staticClass:"notification is-info"},[_vm._v("\n    The page you are trying to reach does not exist. Click "),_c('router-link',{staticClass:"button is-white",attrs:{"to":"/"}},[_vm._v("here")]),_vm._v(" to return to the Homepage.\n  ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }